import $ from "jquery";

const initExceptions = () => {

    $('#exceptions__container').css('height', `calc(100vh - ${$('#exceptions__container').height()}px - ${$('#footer').height()}px - ${$('#nav__container').height()}px)`)
}

$(document).on('turbolinks:load', () => {
        initExceptions()
})